const _version = "1.13.6"
function version() {
    return _version;
}
export default version
